// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2cRZ7","icon":"style_icon__ci0Lb"};